<article class="blog-detail-page">
  <header class="blog-detail-hero">
    <button class="text-button blog-back-button" type="button" (click)="backRequested.emit()">
      <svg class="material-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24">
        <path d="M12 20 4 12l8-8 1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20z" />
      </svg>
      Back to blogs
    </button>
    <p class="blog-meta">{{ postMeta(post) }}</p>
    <h1>{{ post.title }}</h1>
    <p>{{ post.excerpt }}</p>
  </header>

  @if (post.cover_image_url) {
    <figure class="blog-detail-cover">
      <img [src]="post.cover_image_url" [alt]="post.title + ' cover image'" />
    </figure>
  }

  @if (loading) {
    <p class="blog-detail-note">Refreshing article from Django...</p>
  } @else if (error) {
    <p class="blog-detail-note">Showing the last loaded version of this article.</p>
  }

  <section class="blog-detail-body">
    @for (paragraph of post.content.split('\n'); track $index) {
      @if (paragraph.trim()) {
        <p>{{ paragraph }}</p>
      }
    }
  </section>
</article>
